import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  type DeliveryNoteLatestOriginalPdfAdminPayload,
  type DeliveryNoteLatestOriginalPdfAdminResponse,
} from './types';
import { zodDeliveryNoteLatestOriginalPdfAdminEndpointSchema } from './validations';

/**
 * Fetches the latest original delivery note PDF from the admin API.
 * @param assetId - The delivery note asset ID.
 * @param options - Request options, e.g. the abort signal.
 * @returns The PDF as a blob.
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Asset/operation/get_latest_original_pdf_vadmin_asset_delivery_note__asset_id__original_pdf_get
 */
export async function fetchDeliveryNoteLatestOriginalPdfAdmin(
  assetId: DeliveryNoteLatestOriginalPdfAdminPayload['assetId'],
  options: KyRequestOptions = {},
): Promise<DeliveryNoteLatestOriginalPdfAdminResponse> {
  const response = await vestigasApi.get(
    ENDPOINT.DELIVERY.GET_LATEST_ORIGINAL_PDF_ADMIN(assetId),
    {
      validate: {
        pathSegments: zodDeliveryNoteLatestOriginalPdfAdminEndpointSchema,
      },
      ...options,
    },
  );

  return response.blob();
}
